import React from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useMarketPlaceEmailEnterMutation } from '../../generated/graphqlModels';

const DemoButtonGroup = (props: {
  scopeAndSequenceUrl?: string;
  demo?: string;
  programName: string;
  setModalOpen: (_: boolean) => void;
  download: () => void;
}) => {
  const { scopeAndSequenceUrl, demo, setModalOpen, download, programName } = props;
  const [saveEmail] = useMarketPlaceEmailEnterMutation();

  const openOrDownload = () => {
    const email = localStorage.getItem('leadEmail');
    if (email == null) {
      setModalOpen(true);
    } else {
      saveEmail({
        variables: { data: { email, data: { programs: [programName] } } },
      }).finally(() => {
        download();
      });
    }
  };

  return (
    <ButtonGroup
      gap="4"
      justifyContent="center"
      display="flex"
      paddingX={{ base: 0, lg: 8 }}
      marginY={8}
    >
      {demo && (
        <Button colorScheme="stemiRed" variant="solid">
          <Link to={`/demo-sign-up/${demo}/`}>Try Out Demo</Link>
        </Button>
      )}
      {scopeAndSequenceUrl && (
        <Button
          colorScheme="stemiRed"
          variant={demo ? 'outline' : 'solid'}
          onClick={openOrDownload}
        >
          {/* <a href={scopeAndSequenceUrl} target="_blank" rel="noreferrer"> */}
          Download Syllabus
          {/* </a> */}
        </Button>
      )}
      {demo == null && scopeAndSequenceUrl == null && (
        <Button colorScheme="stemiRed" disabled={true}>
          Comming soon
        </Button>
      )}
    </ButtonGroup>
  );
};

export default DemoButtonGroup;
